import axios from "axios";

const performSignInFlow = (authToken) => {
    // console.log('--- SIGN-IN FLOW ---')

    return new Promise(((resolve, reject) => {
        let _url = process.env.VUE_APP_CABINET_V2_API_HOST_USER + '/user/list'
        let _headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + authToken,
            'X-Api-Key': process.env.VUE_APP_X_API_KEY
        }

        if (authToken != null) {
            axios({ method: 'GET', url: _url, headers: _headers }).then((result) => {
                let data = result.data
                let user = data.user
                resolve(user)
            }).catch((error) => {
                // console.log('--- LIST USERS ---')
                console.log(error)
                reject(error)
            })
        } else {
            resolve(null)
        }

    }))
}

const performSignUpFlow = (regInfo, authToken) => {
    console.log('--- SIGN-UP FLOW ---')
    
    return new Promise(((resolve, reject) => {
        let _url = process.env.VUE_APP_CABINET_V2_API_HOST_USER + '/signup'
        let _headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + authToken,
            'X-referrer': 'login',
            'X-Api-Key': process.env.VUE_APP_X_API_KEY
        }
        let _data = {
            "disclaimer": regInfo,
            "country": 'US',
            "firstName": regInfo.firstName,
            "lastName": regInfo.lastName,
            "accountType": regInfo.accountType
        }

        axios({ method: 'POST', url: _url, data: _data, headers: _headers }).then((result) => {
            // console.log('--- SIGN-UP FLOW  ---')
            // console.log(result)
            let data = result.data
            let user = data.user
            resolve(user)
        }).catch((error) => {
            // console.log('--- SIGN-UP FLOW ---')
            // console.log(error)
            reject(error)
        })
    }))
}

export {
    performSignInFlow,
    performSignUpFlow
}